// 'styles' folder is reserved for reusable styled-components
// @ts-ignore
import {
  maxBreakpoints,
  mediaQuery,
  minBreakpoints,
  pxToRem,
  theme,
} from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing } = theme;

export const wrapper = css`
  margin: ${pxToRem(spacing.xl)} 0 ${pxToRem(spacing.xxxxl)};

  ${mediaQuery(
    {
      max: maxBreakpoints.MEDIUM,
    },
    css`
      margin-top: ${pxToRem(spacing.md)};
    `,
  )}
`;

export const pageTitle = css`
  display: block;
  position: absolute;
  width: 1px;
  height: 1px;
  top: -99999px;
  left: -99999px;
`;

export const InfoSection = css`
  max-width: 860px;
  margin: 0 auto;
  ${mediaQuery(
    {
      min: minBreakpoints.MEDIUM,
    },
    css`
      margin-top: ${pxToRem(spacing.lg)};
    `,
  )}
`;

export const CarouselWrapper = css`
  margin: 0 -15px 10px;

  .slick-track {
    left: 10px;
  }
  ${mediaQuery(
    {
      min: minBreakpoints.MEDIUM,
    },
    css`
      margin: 0 -10px;

      .slick-track {
        left: 0px;
      }
    `,
  )}
`;

export const HeroCtaWrapper = css`
  margin: 0 -5px;
  ${mediaQuery(
    {
      min: minBreakpoints.MEDIUM,
    },
    css`
      margin: 0 -10px;
    `,
  )}
`;
